var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "info", class: { "without-arrow": !_vm.arrow } },
    [
      _c("div", { staticClass: "info__text" }, [
        _vm._v("\n    " + _vm._s(_vm.text) + "\n  "),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }